import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import { useEventHighlightPhotoswipe } from "features/events/highlights/concerns/use-event-highlight-photoswipe"
import { GalleryService } from "features/gallery/service/gallery.service"

export class EventLightboxService {
  constructor(
    private _lighboxService: LightboxService,
    private _galleryService: GalleryService,
    private _eventId,
    private _viewContext
  ) {}

  openLightbox(startIndex: number) {
    const { openLightbox } = useEventHighlightPhotoswipe(
      this._eventId,
      this._galleryService,
      this._lighboxService,
      this._viewContext
    )
    openLightbox(startIndex)
  }
}
